<template>
    <div class="ak-html-read-only">
        <iframe
            v-if="isHtml"
            class="ak-html-read-only__frame"
            :srcdoc="value"
            sandbox
            title="Mail inhoud"
        ></iframe>
        <div v-else class="ak-html-read-only__text">{{ value || 'Geen inhoud beschikbaar.' }}</div>
    </div>
</template>

<script>
export default {
    name: 'ak-html-read-only',
    props: {
        value: {
            type: String,
            default: '',
        },
        isHtml: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
